function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M60 72.16C60 41.142 85.072 16 116 16c20.044 0 37.628 10.56 47.522 26.436.183.292.363.586.539.882 5.041 8.43 7.939 18.296 7.939 28.841v.017c.39 5.628.361 11.63 0 17.968V171c0 20.551-14.546 37-36 37v-70.365c7.806-4.881 15.403-13.084 19.07-26.299 3.143.144 7.153-1.796 8.311-5.008l4.148-11.502c1.437-3.986-.523-8.423-4.379-9.909-1.331-.513-3.317-.607-4.886-.347-2.849 2.065-3.074 9.038-3.074 9.038s-4.685-16.986-21.783-17.921c-24.467-1.339-39.046-16.08-41.677-25.85-9.008 8.273-15.138 21.084-16.531 35.783a7.221 7.221 0 00-6.349-.559c-3.855 1.486-5.816 5.923-4.379 9.91l4.097 11.362c1.382 3.831 5.399 5.853 9.132 4.685 3.931 13.593 11.011 21.795 18.3 26.62V208c-20.354 0-36-17.227-36-37.778V72.16z",
  fill: "#2161AA"
});

function SvgHair07(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default __webpack_public_path__ + "static/media/hair-0-7.139d8421.svg";
export { SvgHair07 as ReactComponent };